import { ContactData, ProspectFormData } from '../types';
import { UseFormReturn } from 'react-hook-form';

interface UseProspectFormProps {
  methods: UseFormReturn<ProspectFormData>;
  addContact: (data: ContactData) => Promise<any>;
  setIsLoading: (isLoading: boolean) => void;
  currentWorkspaceId: string;
  showSuccessToast: () => void;
  showErrorToast: (error: unknown) => void;
  status: string;
  onFormSubmit: (success: boolean) => void;
}

export const useProspectForm = ({
  methods,
  addContact,
  setIsLoading,
  currentWorkspaceId,
  showSuccessToast,
  showErrorToast,
  status,
  onFormSubmit
}: UseProspectFormProps) => {
  const { handleSubmit } = methods;

  const handleFormSubmit = handleSubmit(async (data) => {
    if (!currentWorkspaceId) {
      showErrorToast(new Error('No workspace context found. Please reload the page.'));
      onFormSubmit(false);
      return;
    }
    
    setIsLoading(true);

    try {
      // Create contact data object
      const contactData: ContactData = {
        first_name: data.firstName,
        last_name: data.lastName || '',
        email: data.email,
        phone: data.phone,
        workspace_id: currentWorkspaceId,
        extra_fields: {
          industry: data.industry,
          status: status,
          // Add any additional fields here
        }
      };

      // Add the contact
      const { error } = await addContact(contactData);

      if (error) {
        throw error;
      }

      // Show success toast and complete the form submission process
      showSuccessToast();
      onFormSubmit(true);
    } catch (error) {
      showErrorToast(error);
      onFormSubmit(false);
    } finally {
      setIsLoading(false);
    }
  });

  return {
    handleFormSubmit
  };
};
